import { SubCompaniesState, initialState } from "./types";
import {
  FETCH_SUB_COMPANIES,
  FETCH_SUB_COMPANIES_SUCCESS,
  FETCH_SUB_COMPANIES_FAILURE,
} from "./action";

export function SubCompanies(
  state = initialState,
  action: any
): SubCompaniesState {
  switch (action.type) {
    case FETCH_SUB_COMPANIES:
      return {
        ...state,
        fetchCompaniesRequestState: {
          isLoading: true,
          isSuccessful: false,
          isFailed: false,
        },
      };
    case FETCH_SUB_COMPANIES_SUCCESS:
      return {
        ...state,
        companies: action.payload,
        fetchCompaniesRequestState: {
          isLoading: false,
          isSuccessful: true,
          isFailed: false,
        },
      };
    case FETCH_SUB_COMPANIES_FAILURE:
      return {
        ...state,
        fetchCompaniesRequestState: {
          isLoading: false,
          isSuccessful: false,
          isFailed: true,
        },
      };
    default:
      return state;
  }
}
